import { ResourceProps } from "@refinedev/core";
import { IResourceItem } from "@refinedev/core";

export const resources: (ResourceProps | IResourceItem)[] = [
  {
    name: "race_master",
    list: "/races",
    show: "/races/show/:id",
    create: "/races/create",
    edit: "/races/edit/:id",
    meta: {
      label: "レース一覧",
      canDelete: true,
    }
  },
];
